import { MsgBusProviderName } from "@core_n/msg/msg-bus/msg-bus-provider";
import { VideoPlayerInfo } from "./camera.model";

export const EnvironmentNames = {
  Aws: 'aws',
  Sky: 'sky'
}
export type EnvironmentName = typeof EnvironmentNames[keyof typeof EnvironmentNames]

export interface IAppConfig {
  env: {
    name: string;
    enableDebugLogging: true;
  }
  map: {
    esri: boolean;
    name: string;
    refreshRate: number;
    globe: {
      url: string;
    }
  }
  params: {
    trackTrailsCount: number;
    trackVectorLength: number;
    plotsHistory: number;
    azimuth: {
      sensor: {
        length: 3000
      },
      video: {
        length: 1000,
        openDegree: 60
      }
    }
  }
  sharedDataServer: string;
  backendAddress: {
    address: string;
    wsMode: string;
    retryCount: number;
  },
  soundAddress: {
    address: string;
    retryCount: number;
    buffer: number;
  },
  videoAddress: {
    baseURL: string,
    address: string;
    tokenAddress: string;
    cameraTokenAddress: string;
    cameraWebRtcTokenAddress:string, 
    channelChangeAddress: string;
    cameraChannelTable: string;
    cameraGetAnalysisListURL: string;
    cameraSetAnalysisURL: string;
    useTokenOnStream: boolean;
    pullChannelListEvery: number;
    channelsLimit: number;
    numberOfOpenWindows:number;
    setChannelStreamConnectionState: string;
    setChannelDaynamicStreamConnectionState:string;
    videoPlayerInfo: VideoPlayerInfo;
  },
  alertAddress: {
    address: string;
    authAddress: string;
    originResW: number;
    originResH: number;
    enableOverlay: boolean;
  },
  analysisAddress: {
    address: string;
    forwardAddress: string;
    rtspTemplate: string;
    useToken: boolean;
    delay: number;
    limit: number;
  },
  msgBusProvider: MsgBusProviderName;
  environment: EnvironmentName;
  ShowLogs: boolean;
  PreProd: boolean;
  colorScale: any
  AcousticLinesRangeWhiteList: Array<{
    MinVal: number;
    MaxVal: number;
    Classification: string;
  }>
}
